import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { format } from 'date-fns';

export default function CalendarHeader({
  days,
}: {
  days: Array<{ name: string; key: string; date: string }>;
}) {
  const today = format(new Date(), 'yyyy-MM-dd');

  return (
    <>
      <Grid container spacing={0}>
        <Grid
          size="auto"
          sx={{
            borderBottom: '1px solid',
            borderRight: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Box
            sx={{
              p: '10px',
              backgroundColor: 'background.level1',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '80px',
            }}
          />
        </Grid>
        {days.map((day, index) => {
          const isToday = day.date === today;

          return (
            <Grid
              key={day.key}
              size="grow"
              sx={{
                borderBottom: '1px solid',
                borderRight: index < days.length - 1 ? '1px solid' : 'none',
                borderColor: 'divider',
              }}
            >
              <Box
                sx={{
                  p: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: isToday
                    ? 'primary.main'
                    : 'background.level1',
                  color: isToday ? 'primary.contrastText' : 'primary.main',
                  height: '100%',
                  minHeight: '50px',
                }}
              >
                <Typography variant="overline">{day.name}</Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
